import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencySelect } from '@/components/ui';
import {
  currentDisplayCurrency,
  setDisplayCurrency,
  supportedDisplayCurrencies,
} from '@/lib/displayCurrency';

export function CurrencySwitcher({ onChange }: { onChange?: (code: string) => void }) {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(currentDisplayCurrency());

  return (
    <CurrencySelect
      value={current}
      onChange={(v) => {
        setDisplayCurrency(v);
        setCurrent(v);
        onChange?.(v);
      }}
      only={supportedDisplayCurrencies()}
      compact
      width="auto"
      ariaLabel={t('common.currency')}
      className="min-w-[5.5rem]"
    />
  );
}
